import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import * as modelsGet from "../../models/get";
import * as modelsCalendar from "../../models/calendar";
import { getLockPosition } from "../../utils/calendar";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Wenn angegeben, wird hiermit das zugrunde liegende DOM-Element ermittelt.
     */
    appointmentRef?: (ref: HTMLAnchorElement) => void,

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Der momentan selektierte Kalender.
     * Dieser Wert ist immer gefüllt auch wenn keine KalenderGruppe ausgewählt ist. Wenn keine
     * Gruppe ausgewählt ist, beinhaltet diese Eigenschaft den Kalender aus SelectedObject.
     */
    currentSelectedCalendar: modelsGet.ICalendar,

    /**
     * Der Termin der gerendert werden soll.
     */
    appointment?: modelsCalendar.IAvailableAppointment,

    /**
     * Angabe, ob der Termin für die Planungsansicht gerendert werden soll.
     */
    isForPlanningView?: boolean,

    /**
     * Angabe, ob der Termin gesperrt ist.
     */
    isDisabled?: boolean,

    /**
     * Angabe, ob die Position des DOM-Elements "absolute" ist.
     */
    isPositionAbsolute?: boolean,

    /**
     * Angabe, ob der momentan angemeldete Benutzer Termine in der Vergangenheit erstellen darf.
     */
    userCanCreateAppointmentInThePast?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (appointment: modelsCalendar.IAvailableAppointment) => void
}

export class AvailableAppointment extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        isDisabled: false,
        isPositionAbsolute: true
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { appointment, onClick } = this.props;
        onClick && onClick(appointment);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var {
            appointmentRef,
            style,
            currentSelectedCalendar,
            appointment,
            isForPlanningView,
            isDisabled,
            isPositionAbsolute,
            userCanCreateAppointmentInThePast
        } = this.props;

        if (appointment != null)
        {
            var blockPosition = getLockPosition(appointment);
            var date: string = appointment.starttime.toISOString();
            var enddate: string = appointment.endtime.toISOString();
            var setuptimeAfter: number = 0;
            var settings: modelsGet.ICalendarSettings = JSON.parse(currentSelectedCalendar.settings);

            if (settings.time.automatic_setuptime && settings.time.setuptime > 0)
            {
                enddate = moment(appointment.endtime).subtract(settings.time.setuptime, "minutes").toISOString();
                setuptimeAfter = settings.time.setuptime;
            }

            let linkTo: Object = {
                pathname: "/event/new",
                search: "?date=" + date + "&enddate=" + enddate + (setuptimeAfter > 0 ? "&setuptime=" + setuptimeAfter.toString() : "") + (isForPlanningView ? "&calendar=" + currentSelectedCalendar.id.toString() : ""),
                state: {
                    modal: true
                }
            };

            if (!userCanCreateAppointmentInThePast)
            {
                if (moment(date).isBefore(moment()))
                    linkTo = null;
            }
            else if (isDisabled)
            {
                linkTo = null;
            }

            let absolute: React.CSSProperties;
            if (isPositionAbsolute)
            {
                absolute = {
                    position: "absolute"
                }
            }

            return (
                <OptionalLink
                    anchorRef={appointmentRef}
                    className="lock lock--is-free-indicator"
                    style={{
                        ...blockPosition,
                        ...absolute,
                        ...style
                    }}
                    to={linkTo}
                    onClick={this.onClick}>
                    <div className="lock_header-container">
                        <span className="lock_header">
                            Frei
                            </span>
                    </div>
                </OptionalLink>
            );
        }
        else
        {
            return null;
        }
    }
}